import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";

type Props = {
  symbol: string;
  handleComment: (e: CommentFormInputs) => void;
};

type CommentFormInputs = {
  content: string;
};

const validation = Yup.object().shape({
  content: Yup.string()
    .required("Content is required")
    .max(250, "Comment must be at most 250 characters"),
});

const StockCommentForm = ({ symbol, handleComment }: Props) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm<CommentFormInputs>({
    resolver: yupResolver(validation),
  });
  const contentValue = watch("content") || "";
  const remaining = 250 - contentValue.length;

  const onSubmit = (data: CommentFormInputs) => {
    handleComment(data);
    reset();
  };

  return (
    <form className="mt-4 ml-4" onSubmit={handleSubmit(onSubmit)}>
      <div className="py-2 px-4 mb-1 bg-white rounded-lg rounded-t-lg border border-gray-200 dark:bg-gray-800 dark:border-gray-700">
        <label htmlFor="comment" className="sr-only">
          Your comment
        </label>
        <textarea
          id="comment"
          rows={6}
          className="px-0 w-full text-sm text-gray-900 border-0 focus:ring-0 focus:outline-none dark:text-white dark:placeholder-gray-400 dark:bg-gray-800"
          placeholder="Write a comment..."
          maxLength={250}
          {...register("content")}
        ></textarea>
        <div className="mt-2 flex items-center justify-between text-sm text-gray-600 dark:text-gray-300">
          <div className="h-5">
            {errors.content?.message && (
              <span className="text-red-600">{errors.content?.message}</span>
            )}
          </div>
          <div className="text-gray-500">{contentValue.length}/250</div>
        </div>
      </div>
      <button
        type="submit"
        className="inline-flex items-center py-1.5 px-4 text-base font-medium text-center text-white bg-lightGreen rounded-lg focus:ring-4 focus:ring-primary-200 dark:focus:ring-primary-900 hover:opacity-70"
      >
        Post comment
      </button>
    </form>
  );
};

export default StockCommentForm;
